// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__51ptD","dark":"Modal_dark__obztD","bg":"Modal_bg__025eP"};